import {app} from '../../app';
import 'marked';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;
import {StaticSharedQuestion} from "../../sharedQuestions/StaticSharedQuestion";

export class StaticQuestionComponent {

    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    public sharedQuestion: StaticSharedQuestion;
    public question:IQuestion;
    public value:string;

    static $inject = ['SharedQuestionService', 'SessionService'];

    constructor(sharedQuestionService:SharedQuestionService, sessionService:ISessionService) {
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService = sessionService;
    }

    public $onInit = () => {
        this.sharedQuestion = new StaticSharedQuestion();
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();
    };

}

app.component('staticQuestion', {
    templateUrl: 'templates/components/questionTypes/staticQuestion.html',
    controller: StaticQuestionComponent,
    controllerAs: 'staticQuestion',
    bindings: {
        question: '<',
        nextQuestionCallback: '&'
    }
});